﻿<script setup>
    import { useDialogPluginComponent } from 'quasar'
    defineEmits([...useDialogPluginComponent.emits])
    const { dialogRef, onDialogHide, onDialogOK, onDialogCancel } = useDialogPluginComponent()

    const props = defineProps({
        title: String,
        message: String,
        icon: {
            type: String,
            default: 'info'
        },
        size: String
    });

    const input = ref('');

    function onOk() {
        onDialogOK(input.value);
    }
</script>

<template>
    <q-dialog ref="dialogRef" @hide="onDialogHide" :persistent="true">
        <window :title="title" :icon="icon" :size="size">
            <template #actions>
                <q-btn flat label="Cancel" color="dark" @click="onDialogCancel" />
                <q-btn flat label="Ok" color="primary" @click="onOk" :disabled="!input.length" />
            </template>
            {{message}}

            <q-input debounce="100"
                        dense
                        v-model="input"
                        type="textarea"
                        autofocus/>
        </window>
    </q-dialog>
</template>